import { useMutation } from '@tanstack/react-query';
import { createOrderStatusReconciliationJob } from 'config/requests/reconciliation';
import {
  mapReconciliationFormToFormData,
  ReconciliationFormValues,
} from 'pages/Finance/Reconciliation/utils/mapReconciliationFormToFormData';
import { useNotify } from 'react-admin';

export function useReconciliationSubmit() {
  const notify = useNotify();

  return useMutation({
    mutationFn: (values: ReconciliationFormValues) =>
      createOrderStatusReconciliationJob(mapReconciliationFormToFormData(values)),
    onSuccess: () => {
      notify(
        'Автосверка запущена и обрабатывается. После завершения файл с результатами появится в "Уведомлениях".',
        { type: 'success' },
      );
    },
  });
}
